import React, { Component } from "react";
import Helmet from "react-helmet";
import Layout from "../../layout";
import OrganicHeader from "../../components/LayoutElement/OrganicHeader";
import config from "../../../data/SiteConfig";
// import urljoin from "url-join";
import SEO from "../../components/SEO/SEO";
import { Facebook, Twitter, Linkedin, Mail } from "react-social-sharing";
import HealthcareSVG from "../../images/icons/careers/healthcare-icon.svg";
import RetirementSVG from "../../images/icons/careers/401k-icon.svg";
import PtoSVG from "../../images/icons/careers/pto-icon.svg";
import SocialEventsSVG from "../../images/icons/careers/social-events-icon.svg";
import WorkLifeBalanceSVG from "../../images/icons/careers/work-life-balance-icon.svg";
import ProfDevSVG from "../../images/icons/careers/professional-development-icon.svg";

export default class JobPostingTemplate extends React.Component {
  render() {
    const { pageContext } = this.props;
    const jobTitle = pageContext.jobTitle;
    const jobLocation = pageContext.location;

    const shareLink = config.siteUrl + `/openings/posting/` + pageContext.id;

    return (
      <Layout>
        <>
          <Helmet title={`${pageContext.jobTitle} | Apply Now`} />
          <SEO
            jobTitle={jobTitle}
            jobLocation={jobLocation}
            shareLink={shareLink}
            jobPostingSEO
          />
          <section className="shape-based-header sila-teal-to-blue-mix">
            <div className="shape-based-header--message short container">
              <div className="full">
                <h1>
                  {pageContext.jobTitle}
                  <br />
                  <small>{pageContext.location}</small>
                </h1>
                <p>
                  <a
                    className="button white-outline"
                    href={pageContext.applyUrl}
                    target="_blank"
                  >
                    Apply Now
                  </a>
                </p>
              </div>
            </div>
          </section>
          <section className="xt-marg-top">
            <div className="container">
              <div className="job-posting-main">
                <div
                  dangerouslySetInnerHTML={{
                    __html: pageContext.description
                  }}
                />
                {pageContext.lists
                  ? pageContext.lists.map(list => (
                      <>
                        <h3>{list.text}</h3>
                        <div
                          dangerouslySetInnerHTML={{ __html: list.content }}
                        />
                      </>
                    ))
                  : ``}
                <div
                  dangerouslySetInnerHTML={{
                    __html: pageContext.additionalDescription
                  }}
                />
                <p className="xt-pad-top">
                  <a
                    className="button primary"
                    href={pageContext.applyUrl}
                    target="_blank"
                  >
                    Apply Now
                  </a>
                </p>
                <h5>Share this job</h5>
                <aside className="social-sharing">
                  {/* <Location> */}
                  {/* {({ location }) => { */}
                  {/* return ( */}
                  <>
                    <Facebook
                      solid
                      small
                      message={pageContext.jobTitle}
                      link={shareLink}
                    />
                    <Twitter
                      solid
                      small
                      message={pageContext.jobTitle}
                      link={shareLink}
                    />
                    <Linkedin
                      solid
                      small
                      message={pageContext.jobTitle}
                      link={shareLink}
                    />
                    <Mail
                      solid
                      small
                      subject={pageContext.jobTitle}
                      body={shareLink}
                    />
                  </>
                  {/* ); */}
                  {/* }} */}
                  {/* </Location> */}
                </aside>
                <p className="xt-pad-top">
                  <i className="fa fa-arrow-left" />{" "}
                  <a href="/openings">Back to Openings</a>
                </p>
              </div>

              <aside className="job-posting-sidebar">
                <div className="panel">
                  <h3 className="text-center">Benefits</h3>
                  <div className="container">
                    <div className="benefit">
                      <img
                        src={HealthcareSVG}
                        alt=""
                        className="benefit-icon"
                      />
                      <strong>Health & Wellness</strong>
                      <p>
                        Comprehensive healthcare insurance options, flexible
                        spending accounts, disability and life insurance
                      </p>
                    </div>
                    <div className="benefit">
                      <img
                        src={RetirementSVG}
                        alt=""
                        className="benefit-icon"
                      />
                      <strong>401k</strong>
                      <p>
                        Robust 401k plan with matching for your retirement
                        savings
                      </p>
                    </div>
                    <div className="benefit">
                      <img src={PtoSVG} alt="" className="benefit-icon" />
                      <strong>Paid Time Off</strong>
                      <p>Generous PTO allowance, and we actually take it!</p>
                    </div>
                    <div className="benefit">
                      <img src={ProfDevSVG} alt="" className="benefit-icon" />
                      <strong>Professional Development</strong>
                      <p>
                        Core curriculum of training plus a variety of
                        professional development and learning channels
                      </p>
                    </div>
                    <div className="benefit">
                      <img
                        src={SocialEventsSVG}
                        alt=""
                        className="benefit-icon"
                      />
                      <strong>Social Events</strong>
                      <p>
                        Paint nite, races, mixology classes—we have something
                        for everyone at our monthly social events
                      </p>
                    </div>
                    <div className="benefit">
                      <img
                        src={WorkLifeBalanceSVG}
                        alt=""
                        className="benefit-icon"
                      />
                      <strong>Work/Life Balance</strong>
                      <p>
                        We understand and value the importance of life outside
                        of work
                      </p>
                    </div>
                  </div>
                </div>
              </aside>
            </div>
          </section>
        </>
      </Layout>
    );
  }
}
